import React from 'react'
import { useTranslation } from 'react-i18next'

import { Progress } from 'antd'

//
import { AdminTask } from 'core/application/adminDashboard/adminTasks'

type SetupProgressProps = {
  steps: AdminTask[]
  activeStep: number
  title?: string
}

function SetupProgress({ steps, activeStep, title }: SetupProgressProps) {
  const { t: translate } = useTranslation()
  return (
    <div className="profile-setup__progress mb-24">
      <p className="gray-7 mb-0">
        {title ?? translate('admin-dashboard.home.account-setup.progress-bar-label')} {activeStep}/{steps.length}
      </p>
      <div className="profile-setup__progress-bar">
        <Progress
          className="gray-7"
          style={{ width: 200 }}
          percent={parseInt(((activeStep / steps.length) * 100).toFixed(0))}
          showInfo={(activeStep / steps.length) * 100 !== 0}
        />
        {(activeStep / steps.length) * 100 === 0 && (
          <span className="gray-7 ml-8">{translate('admin-dashboard.home.account-setup.progress-not-started')} </span>
        )}
      </div>
    </div>
  )
}

export default SetupProgress
